// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__5w7mh","icon":"Tag_icon__xTtmr","rotation":"Tag_rotation__rZI9e"};